import { render, staticRenderFns } from "./ListBooking.vue?vue&type=template&id=010edbcb&scoped=true"
import script from "./ListBooking.vue?vue&type=script&lang=js"
export * from "./ListBooking.vue?vue&type=script&lang=js"
import style0 from "./ListBooking.vue?vue&type=style&index=0&id=010edbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010edbcb",
  null
  
)

export default component.exports